export default function normalizePath(path: string) {
  let newPath = path;

  if (newPath[0] === '/') {
    newPath = newPath.slice(1);
  }

  return newPath;
}
